function addMaterialsModal () {
  return {
    restrict: 'E',
    templateUrl: '/arts/directives/add-materials-modal/add-materials-modal.html?$$REVISION$$'
  }
}
export { addMaterialsModal }
